// Сообщает загрузчику счётчиков (templates/cookie-consent-loader.html.twig), что выбор по кукам сохранён
const notifyCookieConsentChanged = function() {
  window.dispatchEvent(new Event('cookie-consent-changed'));
};

export default notifyCookieConsentChanged;
